export interface BranchDescriptionProps {
  title: string
  description: any
}

export const useBranchDescription = (props: BranchDescriptionProps) => {
  return {
    ...props,
  }
}
